import styled from "@emotion/styled";
import { MenuSeparator } from "../../../menu";

export interface VirtualizedSeparatorStyledProps {
    optionHeight: number;
    shouldVirtualize?: boolean;
    // Used to position the separator correctly in a virtualized list
    top?: number | string;
}

const shouldForwardProp = (propName: string): boolean => {
    switch (propName) {
        case "optionHeight":
        case "shouldVirtualize":
        case "top":
            // Just add any extra props here :)
            return false;
    }
    return true;
};

export const VirtualizedSeparatorStyled = styled(MenuSeparator, {
    shouldForwardProp,
})<VirtualizedSeparatorStyledProps>`
    ${({ shouldVirtualize, optionHeight, top }) =>
        shouldVirtualize
            ? `
                ${top ? `top: ${+top - optionHeight}px` : ``};
                transform: translate(0, ${optionHeight}px);
                position: absolute;
                width: calc(100% - 32px);
              `
            : ``}
`;
